import { defineStore } from 'pinia'
import type { ContactItem } from '~/utils/interface'
const STORE_NAME = 'contacts'

export const useContactStore = defineStore(STORE_NAME, {
  state: (): { contacts: ContactItem[] } => ({
    contacts: []
  }),
  persist: false,
  actions: {
    setContact(data: ContactItem[]): void {
      this.contacts = data
    }
  }
})
